import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import {
    IChecklistHistoryDateRangeChangeEvent,
    IChecklistV2ReportParameter,
    IOpenChecklistReportWidgetDetailsData,
} from '../../shared/fi-checklist2-report';
import { ObjectTypes } from '@fi-shared/types';
import { FiCommonSharedService } from '@fi-shared/fi-shared-services/fi-common-shared.service';
import { removeItem } from '@fi-shared/utils/remove-item';
import { FiChecklist2ReportType } from '../../enums/fi-checklist2-report-type';
import { FiChecklist2ReportData } from '@fi-shared/checklist/fi-checklist2-report/shared/fi-checklist2-report-data';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

@Component({
    selector: 'fi-checklist2-report-dashboard',
    templateUrl: './fi-checklist2-report-dashboard.component.html',
    styleUrls: ['./fi-checklist2-report-dashboard.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: { class: 'fi-checklist2-report-dashboard' },
    standalone: false,
})
export class FiChecklist2ReportDashboardComponent {
    @Input() auditMode: boolean;
    @Input() reportData: FiChecklist2ReportData;

    @Input() reports: IChecklistV2ReportParameter[] = [];
    @Output() onReportsChange = new EventEmitter<IChecklistV2ReportParameter[]>();
    @Output() onShowWidgetDetails = new EventEmitter<IOpenChecklistReportWidgetDetailsData>();

    constructor(private commonService: FiCommonSharedService) {}

    onReportParameterDeleted(report: IChecklistV2ReportParameter) {
        removeItem(this.reports, report);
        this.onReportsChange.emit(this.reports);
    }

    onReportDrop(event: CdkDragDrop<IChecklistV2ReportParameter[]>) {
        moveItemInArray(this.reports, event.previousIndex, event.currentIndex);
        this.updateSortIndexes();
        this.reports = this.reports.map((report: IChecklistV2ReportParameter, index: number) => {
            report.SortIndex = index;
            return report;
        });
        this.onReportsChange.emit(this.reports);
    }

    showWidgetDetails(reportParam: IChecklistV2ReportParameter, isFilterExpanded: boolean) {
        this.onShowWidgetDetails.emit({ reportParam, isFilterExpanded });
    }

    private updateSortIndexes() {
        this.commonService.updateSortIndexes(this.reports, ObjectTypes.Checklist2Report);
        this.onReportsChange.emit(this.reports);
    }

    protected readonly FiChecklist2ReportType = FiChecklist2ReportType;
}
